import script from "./CTaxCalculatorBusiness.vue?vue&type=script&setup=true&lang=js"
export * from "./CTaxCalculatorBusiness.vue?vue&type=script&setup=true&lang=js"

import "./CTaxCalculatorBusiness.vue?vue&type=style&index=0&id=dd4f54a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd4f54a2"]])

export default __exports__